import {
  ActionType,
  AppContextType,
  DrugCoverageFilterOption,
  PlanSNPType,
} from "../../../@types";
import { SearchFilterKeyMapping, SearchFilterKeys } from "./constants";
import {
  AnalyticsActions,
  AnalyticsActionType,
  Ga4Event,
  Ga4EventType,
} from "../../../app/contexts/Analytics/types";
import { Dispatch } from "react";

export const updateFilter = (
  { state, dispatch }: AppContextType,
  filterName: SearchFilterKeys,
  value: string | string[] | DrugCoverageFilterOption | boolean | undefined
): void => {
  dispatch({
    type: ActionType.UPDATE_SEARCH_RESULTS_FILTERS,
    payload: {
      ...state.searchResultsFilters,
      [filterName]: value,
    },
  });
};

export const searchResultsFilterAnalytics = ({
  text = "",
  filterType,
  filterValue,
  dispatch,
}: {
  dispatch: Dispatch<AnalyticsActions>;
  text?: string;
  filterType: SearchFilterKeys;
  filterValue?: string | boolean;
}) => {
  const filter_name =
    typeof filterValue === "boolean"
      ? filterValue
        ? "true"
        : "false"
      : filterValue;
  dispatch({
    type: AnalyticsActionType.SEND_GA4_EVENT,
    settings: {
      event_name: Ga4Event.RESULTS_FILTERED,
      event_type: Ga4EventType.UI_INTERACTION,
      filter_type: SearchFilterKeyMapping[filterType],
      filter_name,
      text,
    },
  });
};

export const updateSNPFilters = (
  { dispatch }: AppContextType,
  snpTypes: string[] | PlanSNPType[]
): void => {
  const hasNotSnp = snpTypes.includes(PlanSNPType.SNP_TYPE_NOT_SNP);
  if (snpTypes.length && !hasNotSnp) {
    // the snp filters are additive, so if any exist, we need to also send SNP_TYPE_NOT_SNP to the API
    snpTypes.push(PlanSNPType.SNP_TYPE_NOT_SNP);
  } else if (snpTypes.length === 1 && hasNotSnp) {
    snpTypes = [];
  }
  dispatch({
    type: ActionType.UPDATE_SNP_FILTERS,
    payload: snpTypes,
  });
};
